var map = {
	"./GoalSAD.svg": 46428,
	"./add.svg": 77141,
	"./add2.svg": 98272,
	"./add3.svg": 51404,
	"./arrow_up.svg": 31053,
	"./basicModule.svg": 77592,
	"./bottomBg.svg": 20255,
	"./ce.svg": 32468,
	"./cockpit.svg": 17473,
	"./collaborate.svg": 44379,
	"./continue.svg": 79362,
	"./controlAndSchedulingManagement.svg": 38369,
	"./create.svg": 18513,
	"./dataBoard.svg": 98357,
	"./delete-red.svg": 61871,
	"./delete.svg": 48458,
	"./download.svg": 37141,
	"./edit.svg": 5076,
	"./export.svg": 69539,
	"./goBack.svg": 74536,
	"./goBack1.svg": 88014,
	"./icon_jdkp.svg": 29198,
	"./important.svg": 29932,
	"./look.svg": 54591,
	"./modify.svg": 58325,
	"./modify1.svg": 42745,
	"./notselect.svg": 53651,
	"./organization.svg": 24521,
	"./projectEmissionReduction.svg": 76130,
	"./save.svg": 67348,
	"./select-fill.svg": 21820,
	"./select.svg": 45737,
	"./send.svg": 69740,
	"./start.svg": 22711,
	"./submit.svg": 82386,
	"./success.svg": 39873,
	"./tip.svg": 40172,
	"./titleBg.svg": 84566,
	"./upload-icon.svg": 90233,
	"./upload.svg": 74757,
	"./workbench.svg": 38075,
	"./world.svg": 64238
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;